var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.761,
    height: 18.948,
    viewBox: "0 0 33.761 18.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.137,18.948H.748A.748.748,0,0,1,0,18.2V.748A.748.748,0,0,1,.748,0H30.137a.747.747,0,0,1,.748.748V18.2a.747.747,0,0,1-.748.748M1.5,17.452H29.389V1.5H1.5Z",
    transform: "translate(0 0)",
    fill: "#0aadfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.573,12.557a.748.748,0,0,1-.748-.748V3.957a.748.748,0,1,1,1.5,0V11.81a.748.748,0,0,1-.748.748",
    transform: "translate(1.896 1.591)",
    fill: "#002a2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.573,12.557a.748.748,0,0,1-.748-.748V3.957a.748.748,0,1,1,1.5,0V11.81a.748.748,0,0,1-.748.748",
    transform: "translate(3.879 1.591)",
    fill: "#002a2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.573,12.557a.748.748,0,0,1-.748-.748V3.957a.748.748,0,1,1,1.5,0V11.81a.748.748,0,0,1-.748.748",
    transform: "translate(5.862 1.591)",
    fill: "#002a2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.573,12.557a.748.748,0,0,1-.748-.748V3.957a.748.748,0,1,1,1.5,0V11.81a.748.748,0,0,1-.748.748",
    transform: "translate(7.845 1.591)",
    fill: "#002a2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.633,14.158H20.7a.734.734,0,0,1,0-1.469h.935a.738.738,0,0,0,.761-.709v-7.4a.738.738,0,0,0-.761-.709H20.7a.734.734,0,0,1,0-1.469h.935a2.207,2.207,0,0,1,2.23,2.178v7.4a2.207,2.207,0,0,1-2.23,2.178",
    transform: "translate(9.897 1.193)",
    fill: "#0aadfd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.c38f2df0ce343ed0573d5ca374e4c33b.svg";
export { ForwardRef as ReactComponent };